import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHeader = ({ title, subtitle, crumbs = [] }) => {
  return (
    <section className="relative overflow-hidden bg-slate-900 text-white">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-900 to-red-950/40" />
      <div className="lis-container relative py-16 md:py-24">
        <div className="flex items-center gap-2 text-xs text-slate-300">
          <Link to="/" className="hover:text-white">Home</Link>
          {crumbs.map((c, i) => (
            <React.Fragment key={i}>
              <ChevronRight size={12} className="opacity-60" />
              {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white">{c.label}</span>}
            </React.Fragment>
          ))}
        </div>
        <h1 className="mt-4 text-3xl md:text-5xl font-extrabold leading-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-slate-300 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHeader;
